import apiClient from './client';
import { LoginSchema } from 'shared-schemas';

export const authApi = {
  login: async (credentials) => {
    const validated = LoginSchema.parse(credentials);
    const response = await apiClient.post('/api/auth/login', validated);
    return response.data;
  },

  getMe: async () => {
    const response = await apiClient.get('/api/auth/me');
    return response.data;
  },
};